module.exports = __webpack_public_path__ + "img/olympic-volleyball.797b1da8.png";